import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "context/AuthContext";

/**
 * Paths guest demo users may open. All other /dashboard/* routes redirect home.
 */
function isGuestAllowedPath(pathname) {
  const path = pathname.split("?")[0].replace(/\/$/, "") || "/";
  if (path === "/dashboard") return true;
  if (path === "/dashboard/analytics") return true;
  if (path.startsWith("/dashboard/missions")) return true;
  if (path.startsWith("/dashboard/entities")) return true;
  if (path.startsWith("/dashboard/leaderboards")) return true;
  return false;
}

/**
 * Wraps dashboard content; redirects guests away from disallowed routes.
 */
function GuestRouteGuard({ children }) {
  const { isGuest } = useAuth();
  const location = useLocation();

  if (isGuest && !isGuestAllowedPath(location.pathname)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

export default GuestRouteGuard;
